module.exports = __webpack_public_path__ + "img/reply.fa63aaa2.png";